export var VoteTypes = /*#__PURE__*/ function(VoteTypes) {
    VoteTypes[VoteTypes["DisableKarma"] = 0] = "DisableKarma";
    VoteTypes[VoteTypes["TogglePause"] = 1] = "TogglePause";
    return VoteTypes;
}({});
